var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 20.8c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496C14.08 8 16.32 8 20.8 8h22.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 14.08 56 16.32 56 20.8v14.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496C49.92 48 47.68 48 43.2 48h-6.71c-1.664 0-2.496 0-3.292.163a8.001 8.001 0 0 0-2.031.713c-.724.37-1.374.89-2.673 1.929l-6.361 5.089c-1.11.888-1.665 1.331-2.132 1.332-.406 0-.79-.184-1.043-.502-.291-.365-.291-1.075-.291-2.496V48c-2.48 0-3.72 0-4.738-.273a8 8 0 0 1-5.656-5.656C8 41.053 8 39.813 8 37.333V20.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M31.992 20.531c-2.4-2.77-6.4-3.515-9.406-.978-3.006 2.536-3.43 6.778-1.069 9.778 1.463 1.859 5.133 5.253 7.715 7.568.948.85 1.422 1.275 1.991 1.446a2.735 2.735 0 0 0 1.537 0c.57-.171 1.043-.596 1.992-1.446 2.581-2.315 6.252-5.71 7.715-7.568 2.36-3 1.989-7.268-1.07-9.778-3.057-2.51-7.006-1.792-9.405.978Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.efea6a7536c847a661e4aeab42fdf5ee.svg";
export { ForwardRef as ReactComponent };